export default __webpack_public_path__ + "images/0x0b2c639c533813f4aa9d7837caf62653d097ff85.png";